// extracted by mini-css-extract-plugin
module.exports = {"typeWireframe":"Button_typeWireframe__NMOu9","typeFilled":"Button_typeFilled__DJiAe","typeCart":"Button_typeCart__w1sQQ"};